<script>
export default {
  name: "VVideo",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<template>
  <video class="video" controls="controls">
    <source v-if="data.src.mp4" :src="data.src.mp4" type="video/mp4" />
    <source v-if="data.src.mp4" :src="data.src.ogg" type="video/ogg" />
    <source v-if="data.src.mp4" :src="data.src.webm" type="video/webm" />
  </video>
</template>
